import React from "react";
import { IAttentionDay } from "../../domain/attentiondays/IAttentionDay";
import { dateFormat } from "../../helpers/dateHelpers";
import { BaseComponent } from "../core/BaseComponent";

interface AttentionDayRowProps {
    attentionDay: IAttentionDay;
    onRemove: () => void;
    onEdit: () => void;
}

export class AttentionDayRow extends BaseComponent<AttentionDayRowProps> {
    render() {
        const day = this.props.attentionDay;
        return <tr >
            <td className="dagcell clickable" onClick={this.props.onEdit}>{day.name} &nbsp;({day.id})</td>
            <td className="dagcell clickable" onClick={this.props.onEdit}>{this.translate(`attentiondays.kind.${day.kind}`)}</td>
            <td className="dagcell clickable" onClick={this.props.onEdit}>{dateFormat(day.start, "iiii d MMMM yyyy")}</td>
            <td className="dagcell clickable" onClick={this.props.onEdit}>{dateFormat(day.end, "iiii d MMMM yyyy")}</td>
            <td className="dagcell clickable" onClick={this.props.onRemove}>{this.translate(`attentiondays.remove`)}</td>
        </tr>;
    }
}
